<template lang="pug">
    .edi-template
      .entity-content.pa-5
        v-row
          v-col.d-flex.align-center
            h2.primary--text {{ $t('textFileTemplate.title') }}
        v-row
          v-col(cols="2")
            v-select(
              :label="$t('textFileTemplate.fileExtension')",
              v-model="instance.fileExtension",
              :items="validExtensions"
            )
          v-col(cols="2")
            v-select(
              v-if="instance.fileExtension == 'csv'",
              :label="$t('textFileTemplate.delimiter')",
              v-model="instance.delimiter",
              :items="validDelimeters"
            )
        v-row
          h3(v-if="instance.fileExtension == 'csv'") {{ $t('textFileTemplate.DelimeterNotice') }}
        label {{  $t('textFileTemplate.body') }}:
        code-editor(
          v-model="instance.body",
          language="htmlembedded",
          :placeholder="$t('textFileTemplate.fileContentGeneratorCode')"
        )
        v-row
          v-col(cols="12")
            document-request-selector(
              v-model="instance.attachments",
              :currentValues="{applicableOn: instance.entityName, id: instance.documentRequestId, name: instance.documentRequestLabel, entityFileId: instance.entityId}",
              :multiple="false",
              :setEntityFileId="true"
            )
</template>
    
<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>
import DocumentRequestSelector from '@/components/ActionTemplate/DocumentRequestSelector';

export default {
  props: ['value'],
  components: { DocumentRequestSelector },
  data: function ()  {
    return {
      initialObject: {
        entityId: '@Model.Id',
        fileName: null,
        fileExtension: null,
        documentRequestId: null,
        documentRequestLabel: null,
        delimiter: ',',
        body: '',
        entityFileExternalId: '@Model.ExternalId',
        isRazor: true,
      },
      instance: {},
    }
  },
  computed: {
    validExtensions () {
      return [
        "txt",
        "csv",
        "xml",
        "yaml",
        "json",
        "jsonc",
        "svg",
        "zpl",
        "zpl2"
      ]
    },
    validDelimeters () {
      return [
        ",",
        ";",
        "|"
      ]
    }
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        //update values before emit
        if(val && this.instance.attachments)
        {
          val.documentRequestId = this.instance.attachments.id;
          val.entityName = this.instance.attachments.applicableOn;
          val.documentRequestLabel = this.instance.attachments.name;
          val.entityId = this.instance.attachments.entityFileId;
          val.entityFileExternalId = this.instance.attachments.entityFileExternalId;
          delete this.instance.attachments;
        }
        this.$emit('input', val);
      },
    },
  },
  methods: {
    // todo something
  },
  created() {
    this.instance = { ...this.initialObject, ...this.value };
  },
}
</script>
    